import {get} from './common';

export const generateSearchParams = params => `?${Object.keys(params).map(param => `${param}=${params[param]}`).join('&')}`;

export default {
  getSuggestions: async (params, token) => get(`/v1/Streets/GetSuggestion${generateSearchParams(params)}`, token),
  getCityState: async (params, token) => get(`/v1/Account/GetCityState?zip=${params.zip}`, token),
  validateAddress: async (params, token) => get(`/v1/Streets/ValidateAddress${generateSearchParams(params)}`, token),
};
